import * as Yup from "yup";
import formData from "./formData";

const {
  formField: { name, dateOfBirth },
} = formData;

const validationSchema = Yup.object().shape({
  [name.name]: Yup.string().trim().required(`${name.requiredErrorMessage}`),
  [dateOfBirth.name]: Yup.string().required(
    `${dateOfBirth.requiredErrorMessage}`
  ),
});

export default validationSchema;
